import { useEffect } from 'react';
import { Helmet } from 'react-helmet-async';

import { Tabs, TabsStrategy } from '../../components/Tabs';
import { Breadcrumbs } from '../../components/Breadcrumbs';
import {
  PATH_INTERNAL_ORGANIZATIONS,
  PATH_INTERNAL_PEOPLE,
  PATH_INTERNAL_THIRD_PARTIES_DEFAULT,
  PATH_INTERNAL_THIRD_PARTIES_DISABLED,
} from '../../app/constants/paths.constant';
import { Page } from '../../contexts/NavigationContext/enums/page.enum';
import { useNavigationContext } from '../../contexts/NavigationContext/hooks/useNavigationContext.hook';
import { buildDocumentTitle } from '../../utils/document-title.util';
import { PageTitle } from '../../components/PageTitle';

import { PeopleTabPanel } from './People';
import { OrganizationsTabPanel } from './Organizations';
import { DisabledTabPanel } from './Disabled';

export const InternalThirdPartiesPage = () => {
  const { setPage } = useNavigationContext();

  useEffect(() => {
    setPage(Page.InternalThirdParties);
  }, [setPage]);

  return (
    <>
      <Helmet>
        <title>{buildDocumentTitle('Organisation SOCNA')}</title>
      </Helmet>
      <Breadcrumbs
        paths={[
          {
            to: PATH_INTERNAL_THIRD_PARTIES_DEFAULT,
            label: 'organisation socna',
            key: 'internalThirdParties',
          },
        ]}
      />
      <PageTitle title="Organisation SOCNA" />
      <Tabs
        id="internal-third-parties-tabs"
        strategy={TabsStrategy.RouterConnected}
        tabs={[
          {
            key: 'internalOrganizations',
            label: 'Sociétés',
            panel: <OrganizationsTabPanel isInternal />,
            to: PATH_INTERNAL_ORGANIZATIONS,
          },
          {
            key: 'internalPeople',
            label: 'Personnes',
            panel: <PeopleTabPanel isInternal />,
            to: PATH_INTERNAL_PEOPLE,
          },
          {
            key: 'internalDisabledThirdParties',
            label: 'Tiers Inactifs',
            panel: <DisabledTabPanel isInternal />,
            to: PATH_INTERNAL_THIRD_PARTIES_DISABLED,
          },
        ]}
        title="Onglets de l'écran de Liste des Tiers de l'Organisation SOCNA"
      />
    </>
  );
};
